import { noop } from 'lodash';
import { func } from 'prop-types';

const ModalPropTypes = {
  showModal: func,
  hideModal: func,
  refreshModalProps: func,
};

export const ModalDefaultProps = {
  showModal: noop,
  hideModal: noop,
  refreshModalProps: noop,
};

export default ModalPropTypes;
